import {db, subscribersCollection} from "../firebase"

export default {
    getSubscribers() {
        let subscribers = [];

        subscribersCollection
            .get()
            .then((querySnapshot) => {
                querySnapshot.forEach((doc) =>{
                    subscribers.push({
                        id: doc.id,
                        email: doc.data().email,
                        first_name: doc.data().first_name,
                        last_name: doc.data().last_name,
                        message: doc.data().message,
                        subject: doc.data().subject,
                    });
                    // eslint-disable-next-line no-console
                    console.log(doc.id, " => ", doc.data());
                });
                return subscribers

            })
            .catch((error) => {
                // eslint-disable-next-line no-console
                console.log("Error getting documents: ", error);
            })
    },
    createSubscriber(subscriber) {
        db.collection("Subscribers")
            .add(subscriber)
            .then(() => {
                console.log("Document successfully written!");

            })
            .catch((error) => {
                console.error("Error writing document: ", error);
            })
    }
}
